import { Layout } from "@/components/Layout";

export default function Terms() {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <h1 className="font-display font-extrabold uppercase tracking-wide text-4xl text-[#0f172a]">Terms &amp; Conditions</h1>
        <div className="mt-6 text-slate-600 space-y-4 leading-relaxed text-sm" data-testid="terms-content">
          <p>Welcome to YourRaceFinder. By using our platform you agree to these terms.</p>
          <h3 className="font-bold text-slate-800 text-base">Race Listings</h3>
          <p>Race organizers are responsible for the accuracy of their listings, including dates, fees, categories and registration information. Registration for races is handled directly by the organizer on their own website.</p>
          <h3 className="font-bold text-slate-800 text-base">User Accounts</h3>
          <p>Users are responsible for maintaining the confidentiality of their account credentials and for all activity carried out through their account. Organizers are responsible for ensuring that the information submitted for their race listings is accurate and up to date.</p>
          <h3 className="font-bold text-slate-800 text-base">Liability</h3>
          <p>YourRaceFinder is a discovery platform and is not responsible for the conduct, cancellation, postponement or changes to any listed event.</p>
        </div>
      </div>
    </Layout>
  );
}
